import { render, staticRenderFns } from "./ContractDetail_view.vue?vue&type=template&id=8a310324&scoped=true"
import script from "./ContractDetail_view.vue?vue&type=script&lang=js"
export * from "./ContractDetail_view.vue?vue&type=script&lang=js"
import style0 from "./ContractDetail_view.vue?vue&type=style&index=0&id=8a310324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a310324",
  null
  
)

export default component.exports